export const TG_AUTH_URL = import.meta.env.VITE_TG_AUTH_URL;


export const TWA_SCRIPT_URL = 'https://telegram.org/js/telegram-web-app.js';
export const TWA_SCRIPT_HASH = 'sha384-rrYCDcTm7U/NeMS1/3PpsuYOwjAtiQZUyC8dUH9dudYxQ3BioJkRzB8ueU0oZ7zg';

export const BASE_URL_PREFIX = '';
export const NATIVE_COIN_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
export const LANGUAGE_COOKIE_KEY = 'app-language';
export const I18N_ROUTE_NAME_SEPARATOR = '___';

